import { EXAM_REG_ENDPOINTS } from "../constants/api";
import { privateApiClient } from "../utils/axios.utils";
import { ExamRegistrationPayload } from "../types/types";

/**
 * Exam Type Service
 * This service handles all API calls related to exam Types.
 */
export const ExamRegistrationService = {
  /**
   * Create a new batch of exam registrations
   */
  createNewRegistration: async (data: ExamRegistrationPayload) => {
    const response = await privateApiClient.post(
      EXAM_REG_ENDPOINTS.CREATE,
      data
    );
    return response.data.data;
  },

  /**
   * Update an existing batch of exam registrations
   */
  updateRegistration: async (id: string, data: ExamRegistrationPayload) => {
    const response = await privateApiClient.put(
      EXAM_REG_ENDPOINTS.UPDATE(id),
      data
    );
    return response.data.data;
  },

  /**
   * Fetch exam registrations for the authenticated user's school
   */
  getOwnSchoolRegistrations: async (page?: number, limit?: number) => {
    const response = await privateApiClient.get(
      EXAM_REG_ENDPOINTS.GET_OWN_SCHOOL_REG,
      { params: { page, per_page: limit } }
    );

    return response.data;
  },

  /**
   * Fetch a single exam registration by ID
   */
  getRegistration: async (id: string) => {
    const response = await privateApiClient.get(
      EXAM_REG_ENDPOINTS.GET_BY_ID(id)
    );
    return response.data.data;
  },

  /**
   * Delete an exam registration by ID
   */
  deleteRegistration: async (id: number) => {
    const response = await privateApiClient.delete(
      EXAM_REG_ENDPOINTS.DELETE(id)
    );
    return response.data.data;
  },

  /**
   * Update a batch of exam registrations
   */
  batchUpdateRegistrations: async (data: ExamRegistrationPayload) => {
    const response = await privateApiClient.put(
      EXAM_REG_ENDPOINTS.BATCH_UPDATE,
      data
    );
    return response.data.data;
  },

  /**
   * Delete a batch of exam registrations
   */
  batchDeleteRegistrations: async (ids: number[]) => {
    const response = await privateApiClient.delete(
      EXAM_REG_ENDPOINTS.BATCH_DELETE,
      { data: { ids } }
    );
    return response.data.data;
  },
};
